'use client';

import { createContext } from 'react';

import type { FilterChipWithMenuContextInterface } from '../types/filter-chip-with-menu-root.types';

export const FilterChipWithMenuContext = createContext<FilterChipWithMenuContextInterface>({
  isToggledOn: false,
  setIsToggledOn: () => {},
});

FilterChipWithMenuContext.displayName = 'FilterChipWithMenu.Context';
